import React, { Fragment } from "react";
import { CardHeader, Col, Row, Card, Spinner } from "reactstrap";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import BarChart from "components/shared/Charts/BarChart";
import { RepositoryFactory } from "repository/RepositoryFactory";

const Stats = RepositoryFactory.get("stats");

const SellersChart = ({ type, dates, merchant }) => {
  const { startDate, endDate } = dates;
  const { user } = useSelector((state) => state.auth);

  const payload = {
    type,
    dateRange: { startDate, endDate },
    id:
      user?.type === "restaurant"
        ? user?.restaurantID
        : user?.type === "admin" && merchant?.id
        ? merchant?.id
        : ""
  };

  const {
    data: latestSellers,
    isFetching,
    isError,
    error
  } = useQuery({
    queryKey: ["sellersChart", payload],
    queryFn: async () => {
      const { data } = await Stats.getSellersCharts(payload);
      return data?.data;
    },
    staleTime: 60 * 60 * 1000,
    cacheTime: 70 * 60 * 1000,
    keepPreviousData: true
  });

  if (isError) {
    toast.error(error?.message || "Failed to load sellers chart.");
  }

  const getChartOptions = (sellers) => ({
    chart: {
      type: "bar",
      toolbar: { show: false }
    },
    xaxis: {
      categories: sellers?.length
        ? sellers.map((item) => item.name.split(" ")[0])
        : [],
      labels: { style: { fontFamily: "Poppins, sans-serif" } }
    },
    ...(sellers?.length && {
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: sellers?.length === 1 ? "5%" : "17%"
        }
      }
    }),
    tooltip: { enabled: true },
    dataLabels: { enabled: false }
  });

  const getSeries = (sellers) => [
    {
      name: "Quantity",
      data: sellers?.map((item) => item.amount) || []
    }
  ];

  return (
    <>
      {["Best", "Worst"].map((label, index) => {
        const sellersKey = label.toLowerCase() + "Sellers";
        return (
          <Fragment key={index}>
            <Row>
              <Col md={12}>
                <Card className="header-cards card overflow-hidden">
                  <CardHeader className="d-flex justify-content-between flex-column flex-sm-row">
                    <h3 className="mb-0">{label} Sellers</h3>
                  </CardHeader>
                  {isFetching ? (
                    <Spinner
                      size="sm"
                      color="primary"
                      className="mx-auto my-5"
                    />
                  ) : (
                    <BarChart
                      options={getChartOptions(latestSellers?.[sellersKey])}
                      series={getSeries(latestSellers?.[sellersKey])}
                    />
                  )}
                </Card>
              </Col>
            </Row>
            <br />
          </Fragment>
        );
      })}
    </>
  );
};

export default SellersChart;
